module.exports = __webpack_public_path__ + "img/250.e4ffa986.png";